'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _DateRangeJs = require('./DateRange.js');

var _DateRangeJs2 = _interopRequireDefault(_DateRangeJs);

var _CalendarJs = require('./Calendar.js');

var _CalendarJs2 = _interopRequireDefault(_CalendarJs);

var _defaultRangesJs = require('./defaultRanges.js');

var _defaultRangesJs2 = _interopRequireDefault(_defaultRangesJs);

exports['default'] = { DateRange: _DateRangeJs2['default'], Calendar: _CalendarJs2['default'], defaultRanges: _defaultRangesJs2['default'] };
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-date-range/lib/index.js
// module id = 704
// module chunks = 0